import { ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import '../Home/Home.css';
import './Ecosystem.css';

function EcosystemPage() {
    const { t } = useTranslation('ecosystem');
    return (
        <div className="ecosystem-page">
            <div className="page-heading">
                <div>
                    <h1>{t('heading.title')}</h1>
                    <p>{t('heading.subtitle')}</p>
                </div>
            </div>

            <section className="ecosystem-page__hero">
                <span className="ecosystem-page__eyebrow">{t('hero.eyebrow')}</span>
                <h2>{t('hero.title')}</h2>
                <p>{t('hero.description')}</p>
                <a
                    className="ecosystem-page__cta"
                    href="https://apc.xyz/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('hero.visit')}
                    <ExportOutlined />
                </a>
            </section>

            <div className="ecosystem-page__grid">
                <section className="panel">
                    <h2>{t('cards.account.title')}</h2>
                    <p>{t('cards.account.description')}</p>
                </section>
                <section className="panel">
                    <h2>{t('cards.wallet.title')}</h2>
                    <p>{t('cards.wallet.description', { amount: 1 })}</p>
                </section>
                <section className="panel">
                    <h2>{t('cards.purchases.title')}</h2>
                    <p>{t('cards.purchases.description')}</p>
                </section>
            </div>
        </div>
    );
}

export default EcosystemPage;
